<template>
	<div class="about11">
		<div class="about11-c">
			<img src="../../assets/about/编组 5.png" alt="">
		</div>
		
	    
		
	</div>
</template>

<script>
	export default {
		props: {
			list: {
				type: Array,
				default: []
			}
		},
		data() {
			return {

			}
		},
		created() {

		},
		methods: {

		}
	}
</script>

<style lang="scss">
	div {
		box-sizing: border-box;
	}

	.about11 {
		.about11-c {
			background-color: white;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			
		}
	
	    
	
	}
	
	@media screen and (min-width: 1200px) {
		.about11 {
			width: 100%;
			display: flex;
			justify-content: center;
			.about11-c {
				width: 1200px;
				padding: 120px 0 120px;
				display: flex;
				img {
					width: 100%;
				}
			}
		}
	
	}
	@media screen and (max-width: 1200px) {
		.about11 {
			width: 100%;
			.about11-c {
				width: 100%;
				padding: 80px 20px;
				display: flex;
				img {
					width: 100%;
				}
			}
		}
	
	}
	@media screen and (max-width: 880px) {
		.about11 {
			width: 100%;
			.about11-c {
				width: 100%;
				padding: 40px 12px;
				display: flex;
				img {
					width: 100%;
				}
			}
		}
	
	}
</style>
